import { type FC } from 'react';
import LabelIcon from '@mui/icons-material/Label';
import { Box, MenuItem, TextField } from '@mui/material';

import { getLabelColor, LABEL_COLOR_TOKENS } from '../../pastelPalette';

export interface LabelColorSelectProps {
  value: string;
  onChange: (token: string) => void;
}

/**
 * Compact pastel color picker for a label (GDN-2019). Renders the filled
 * `LabelIcon` tinted with each token so the chooser reads as a swatch list.
 */
export const LabelColorSelect: FC<LabelColorSelectProps> = ({
  value,
  onChange,
}) => (
  <TextField
    select
    size="small"
    label="Color"
    value={value}
    onChange={e => onChange(e.target.value)}
    sx={{ width: 132 }}
  >
    {LABEL_COLOR_TOKENS.map(token => (
      <MenuItem key={token} value={token}>
        <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
          <LabelIcon sx={{ fontSize: 16, color: getLabelColor(token) }} />
          <span>{token}</span>
        </Box>
      </MenuItem>
    ))}
  </TextField>
);
